import type { DiscountListType } from "@/features/cart/types/discount.type";
import { GET } from "@/lib/methods";

export const getDiscountsList = ({
  params,
  client = false,
}: {
  params?: RequestInit;
  client?: boolean;
}) => {
  const requestParams = {
    next: client
      ? {}
      : {
          tags: ["discounts-list"],
          revalidate: 3600,
        },
    ...params,
  };

  return GET<DiscountListType>({
    url: `${process.env.NEXT_PUBLIC_FOOAPP_URL}/coupons/public/cart`,
    params: requestParams,
  });
};
